import React, { useEffect } from "react";
import { Grid, Card, Switch, Tooltip } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

const BootingRevenuePermissionCard = (props) => {
  const { modules, setModules } = props;
  useEffect(() => {
    if (modules.Booting_revenue_view === undefined) {
      setModules((prevModules) => ({
        ...prevModules,
        Booting_revenue_view: true,
        Booting_revenue_add: true, 
        Booting_revenue_update: true, 
        Booting_revenue_delete: true
      }));
    }
  }, [modules, setModules]);


  const handleUsersViewChange = (event) => {
    const isUsersViewEnabled = event.target.checked;
    setModules({
      ...modules,
      Booting_revenue_view: isUsersViewEnabled,
      ...(isUsersViewEnabled
        ? {}
        : { Booting_revenue_add: false, Booting_revenue_update: false, Booting_revenue_delete: false }),
    });
  };

  return (
    <>
      <Card sx={{ minWidth: 275, boxShadow: 3 }}>
        <MDBox p={2}>
          <Grid container spacing={1}>
            <Grid item xs={12} container alignItems="center">
              <MDTypography
                color="dark"
                display="block"
                variant="subtitle2"
                fontWeight="bold"
                sx={{ flex: 1 }}
              >
               Booting Revenue Module
              </MDTypography>
              <Tooltip
                title={`${
                  modules.Booting_revenue_view ? "Disable" : "Enable"
                } Booting Revenue module`}
                placement="top"
              >
                <Switch
                  checked={modules.Booting_revenue_view}
                  onChange={handleUsersViewChange}
                  disabled={!modules.Role_view}
                />
              </Tooltip>
            </Grid>

            <Grid item xs={12}>
              <Grid container spacing={2}>
                <Grid item xs={6} md={4}>
                  <MDTypography variant="caption" fontWeight="regular">
                    Add Booting Revenue
                  </MDTypography>

                  <Switch
                    checked={modules.Booting_revenue_add}
                    onChange={(event) =>
                      setModules({
                        ...modules,
                        Booting_revenue_add: event.target.checked,
                      })
                    }
                    disabled={!modules.Booting_revenue_view || !modules.Role_view}
                  />
                </Grid>

                <Grid item xs={6} md={4}>
                  <MDTypography variant="caption" fontWeight="regular">
                    Update Booting Revenue
                  </MDTypography>
                  <Switch
                    checked={modules.Booting_revenue_update}
                    onChange={(event) =>
                      setModules({
                        ...modules,
                        Booting_revenue_update: event.target.checked,
                      })
                    }
                    disabled={!modules.Booting_revenue_view || !modules.Role_view}
                  />
                </Grid>

                <Grid item xs={6} md={4}>
                  <MDTypography variant="caption" fontWeight="regular">
                    Delete Booting Revenue
                  </MDTypography>
                  <Switch
                    checked={modules.Booting_revenue_delete}
                    onChange={(event) =>
                      setModules({
                        ...modules,
                        Booting_revenue_delete: event.target.checked,
                      })
                    }
                    disabled={!modules.Booting_revenue_view || !modules.Role_view}
                  />
                </Grid>
              </Grid>
            </Grid>
          </Grid>
        </MDBox>
      </Card>
    </>
  );
};

export default BootingRevenuePermissionCard;
